type RateUpdateCallback = (rate: number) => void;

class RateEventEmitter {
    private listeners: Set<RateUpdateCallback> = new Set();

    on(callback: RateUpdateCallback) {
        this.listeners.add(callback);
    }

    off(callback: RateUpdateCallback) {
        this.listeners.delete(callback);
    }
    emit(rate: number) {
        this.listeners.forEach(callback => {
            try {
                callback(rate);
            } catch (error) {
                console.error('Ошибка в обработчике события обновления курса:', error);
            }
        });
    }

    getListenerCount(): number {
        return this.listeners.size;
    }
}


export const rateEvents = new RateEventEmitter();

export const RATE_EVENTS = {
    UPDATED: 'rate_updated',
} as const;

